import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { ResponseError } from '../errors/ResponseError';
import { IMarkedList } from '../types/seo';
import {
  fetchGetMarkedList,
  TGetMarkedListRequest,
  TGetMarkedListResponse,
} from '../repositories/countryside-search/v3/get-marked-list';

export async function getSeoMarkedList(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: TGetMarkedListRequest,
): Promise<IMarkedList | null> {
  try {
    const { response, statusCode }: TGetMarkedListResponse = await fetchGetMarkedList({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSeoMarkedList',
        message: response.message,
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response.markedList;
  } catch (error) {
    logger.warning(error, { degradation: 'Получение маркированного списка' });

    return null;
  }
}
